import { Link } from 'react-router-dom';


const NotFoundPage = () => {
    return (
            <div className="notfoundpage">
                <div className="pageContent pt-5  h-100">
                    <div className="container-fluid px-0 h-100">
                        <div className="d-flex flex-column justify-content-between h-100">
                            <div className='text-center py-5'>
                                <img src={require('../assets/images/404Logo.png')} alt='logo' className='img-fluid' />
                            </div>
                            <div className='notfoundBot'>
                                <div className='text-center transformY60'>
                                    <img src={require('../assets/images/404bg-img.png')} alt='404bg-img.png' className='img-fluid' />
                                </div>
                                <div className='text-center'>
                                    <Link to='/' className='btn btn-primary px-4'>Back to Home</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


    )
}

export default NotFoundPage;